/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer, Typography2, breakpoints, typography2 } from '@coursera/cds-core';

const styles = {
  section: css`
    & + & {
      margin-top: var(--cds-spacing-200);
    }
  `,
  stickToPrevious: css`
    margin-top: calc(var(--cds-spacing-400) * -1);
  `,
  sectionContent: css`
    display: flex;
    gap: var(--cds-spacing-150);
    flex-direction: column;
  `,
  sectionTitle: css`
    ${breakpoints.down('xs')} {
      ${typography2.subtitleMedium};
    }
  `,
};

type Props = {
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  /** Test ID for E2E tests. Should be module-type based (e.g., 'domain-pills'), not content-based. */
  dataTestId?: string;
  /** When true, removes the top margin applied between adjacent sections (Contentful stickToPrevious). */
  stickToPrevious?: boolean;
};

const Section = React.forwardRef<HTMLDivElement, Props>(
  ({ children, title, className, style, dataTestId, stickToPrevious }, ref) => {
    return (
      <section
        css={[styles.section, stickToPrevious && styles.stickToPrevious]}
        className={className}
        style={style}
        ref={ref}
        data-testid={dataTestId}
      >
        <PageGridContainer>
          <Grid item xs={12} css={styles.sectionContent}>
            {title && (
              <Typography2 variant="subtitleLarge" component="h2" css={styles.sectionTitle}>
                {title}
              </Typography2>
            )}
            {children}
          </Grid>
        </PageGridContainer>
      </section>
    );
  }
);

export default Section;
